module.exports = __webpack_public_path__ + "img/backward.434f566c.svg";